import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import type { SearchBookingResponse } from 'app/typings/core/extranet/bookings/bookings';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export type BookingFilters = {
  pageNumber?: number;
  search?: string;
  beginning?: string;
  ending?: string;
  sortingColumn?: string;
  sortingOrder?: 'ASC' | 'DESC';
  status?: string[];
  vccStatus?: string[];
  packageIds?: string[];
};

export function useBookings(
  hotelId: number,
  queryParams: BookingFilters = {},
  options?: { enabled?: boolean }
) {
  const formattedQueryParams = useMemo(() => queryParams, [queryParams]);

  const key = useMemo(() => {
    return [CORE_QUERY_KEYS.bookings, hotelId, { ...formattedQueryParams }];
  }, [hotelId, formattedQueryParams]);

  return useQuery({
    queryKey: key,
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getBookings,
        params: { hotelId: hotelId.toString() },
        queryParams: formattedQueryParams,
      }) as Promise<SearchBookingResponse>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId && options?.enabled,
  });
}
